import qs from 'query-string'
import { parseStringPromise  } from 'xml2js'
import client from '@/store/client'
import parseData from '../util/parsedata'
// import _ from 'lodash'

const getDefaultState = () => {
  return {
    promoGroupId: '',
    promotionType: '',
    group: '',
    status: '1',
    updatedBy: '',
    updatedDate: '',
    revision: ''
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    allPromoGroups: [],
    promoTypes: [],
    headers: [
      {
        text: 'ID',
        value: 'ID'
      },
      {
        text: 'Promotion Type Name',
        value: 'PromotionTypeID'
      },
      {
        text: 'Promotion Group Name',
        value: 'Name'
      },
      {
        text: 'Row Status Type',
        value: 'RowStatus'
      }
    ]
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SET_FIELD_OBJ: ({ commit }, data) => {
      commit('setFieldObj', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    GET_PROMOTION_TYPES: async function({ commit }) {
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetPromotionTypes', qs.stringify(this.getters['traceToken']))
        commit('setPromoTypes', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_PROMOTIONGROUPS_RETAILER_ID: async function({ commit }) {
      try {
        const APIRes = await client.post('/v1/Promotion.asmx/GetPromotionGroupsByRetailerID', qs.stringify(this.getters['promotionGroups/getPromoGroupsData']))
        commit('setPromoGroups', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_PROMO_GROUP: async function({ commit }, data){
      try {
        const APIRes = await client.post('/v1/Promotion.asmx/GetPromotionGroup', qs.stringify({...this.getters['traceToken'], promotionGroupID: data}))
        const parseResults = await parseStringPromise(APIRes.data)
        commit('setPromoGroup', parseResults.content.data[0].$)
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_PROMO_GROUP: async function({state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Promo Group',
          subdetail: 'Please wait...',
        })
        const updateData = {
          ...this.getters['promotionGroups/currentPromoGroupData'],
          promotionGroupID: state.promoGroupId,
          revision: state.revision
        }
        await client.post('/v1/Promotion.asmx/UpdatePromotionGroup', qs.stringify(updateData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Promo Group ${ updateData.promotionGroupID } has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Promotion Group did not update',
          subdetail: err.response.data,
        })
      }
    },
    INSERT_PROMO_GROUP: async function(){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Promo Group',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Promotion.asmx/InsertPromotionGroup', qs.stringify(this.getters['promotionGroups/currentPromoGroupData']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Promo Group has been successfully created`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Promotion Group was not created',
          subdetail: err.response.data,
        })
      }
    },
  },
  getters: {
    getPromoGroupsData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        merchantID: rootState.retailer.retailerInfo.MerchantID,
        retailerID: rootState.retailer.retailerInfo.ID,
        promotionTypeID: 0,
        rowStatusTypeID: 0,
      }
    },
    currentPromoGroupData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        merchantID: rootState.retailer.retailerInfo.MerchantID,
        retailerID: rootState.retailer.retailerInfo.ID,
        promotionTypeID: state.promotionType,
        promotionGroupName: state.group,
        rowStatusTypeID: state.status
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    setFieldObj: function(state, data) {
      state[data.obj][data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setPromoGroups: function(state, data){
      state.allPromoGroups = data
    },
    setPromoTypes: function(state, data) {
      state.promoTypes = data
    },
    setPromoGroup: function(state, data) {
      state.promotionType = data.PromotionTypeID
      state.group = data.Name
      state.updatedBy = data.LastUpdatedBy
      state.updatedDate = data.LastUpdateDate
      state.status = data.RowStatus
      state.promoGroupId = data.ID
      state.revision = data.Revision
    }
  }
}